import Hero from '@/components/Hero'
import Intro from '@/components/Intro'
import Philosophy from '@/components/Philosophy'
import Services from '@/components/Services'
import Process from '@/components/Process'
import Testimonials from '@/components/Testimonials'
import BlogPreview from '@/components/BlogPreview'
import QuoVadisModal from '@/components/QuoVadisModal'
import Contact from '@/components/Contact'

export default function Home() {
  return (
    <>
      <Hero />
      <Intro />
      <Philosophy />
      <Services />
      <Process />
      <Testimonials />
      <BlogPreview />
      <QuoVadisModal />
      <Contact />
    </>
  )
}
